var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000062172876440655692620000007065786346513677733_",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_49",
    d: "m296.5 395.5c-27.3-27.3-27.3-71.7 0-99s71.7-27.3 99 0 27.3 71.7 0 99c-27.4 27.3-71.7 27.3-99 0zm99-180c27.3-27.3 27.3-71.7 0-99s-71.7-27.3-99 0-27.3 71.7 0 99 71.7 27.3 99 0zm-180 180c27.3-27.3 27.3-71.7 0-99s-71.7-27.3-99 0-27.3 71.7 0 99c27.4 27.3 71.7 27.3 99 0zm0-180c27.3-27.3 27.3-71.7 0-99s-71.7-27.3-99 0-27.3 71.7 0 99 71.7 27.3 99 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotblack);
export default __webpack_public_path__ + "static/media/dotblack.6db7df798f116d8c87914581e7ccaf01.svg";
export { ForwardRef as ReactComponent };